import Icon from "hardcover-ui/components/Icon";
import { IconThemeProps } from "hardcover-ui/theme/components/icon";
import {
  ReadingFormatIDType,
  ReadingFormatByID,
} from "types/ReadingFormatType";

type Props = {
  readingFormatId: number | ReadingFormatIDType;
  className?: string;
  iconType?: "solid" | "regular";
  size?: IconThemeProps["size"];
};

export default function ReadingFormatIcon({
  readingFormatId = 1,
  className = "",
  iconType = "solid",
  size = "md",
}: Props) {
  const format = ReadingFormatByID[readingFormatId];
  if (format) {
    return (
      <Icon
        icon={iconType === "solid" ? format.icon : format.iconRegular}
        className={className}
        size={size}
      />
    );
  }
  return <></>;
}
